<div>
    <div class="chart-filters">
        <ng-container *ngIf="filters">
            <div class="date-range" *ngIf="filters.dateRange">
                <span>{{(filters | chartDateFilter).fromDate}} {{'PLACEHOLDERS.TO' | translate}} {{(filters | chartDateFilter).toDate}}</span>
            </div>
            <div class="gender" *ngIf="filters.gender">
                <span>{{'GENDER.'+filters.gender | translate}}</span>
            </div>
            <div class="time-range" *ngIf="filters.timeRange">
                <span>{{'DASHBOARD.PEAK_REPORT.'+filters.timeRange.toUpperCase() | translate}}</span>
            </div>
            <div class="selected-year" *ngIf="filters.selectedYear">
                <span>{{'#'+filters.selectedYear}}</span>
            </div>
            <div class="categories" *ngIf="filters.categories?.length">
                <ng-container *ngFor="let category of filters.categories; let i = index;">
                    <ng-container *ngIf="i <= 1">
                        <span>#{{language == 'en' ? category.categoryNameEn : category.categoryName}}</span>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="filters.categories?.length > 2">
                    <span class="extra">+{{filters.categories.length - 2}}</span>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="active-users">
        <ng-container *ngFor="let data of headerData">
            <div class="user-data">
                <ng-container *ngIf="data.showCustomLabel; else default">
                    <ng-template [ngTemplateOutlet]="customLabelTemplate" [ngTemplateOutletContext]="{$implicit: data.label}"></ng-template>
                </ng-container>
                <ng-template #default>
                    <p>{{data?.label}}</p>
                </ng-template>
                <div class="active-number">
                    <span class="number">{{ isPercentage ? (data?.count | percent) : data?.count}}</span>
                    <ng-container *ngIf="data?.changeRate">
                        <div class="percent"
                            [ngClass]=" (data.changeRate > 0) ? 'inc' : (data.changeRate < 0) ? 'dec' : 'none'">
                            <span>{{data.changeRate}}%</span>
                            <mat-icon *ngIf="data.changeRate > 0">arrow_upward</mat-icon>
                            <mat-icon *ngIf="data.changeRate < 0">arrow_downward</mat-icon>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>